module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/symbol-observable/index.js
// module id = 588
// module chunks = 0